import React from 'react';
import ImageUploading, { ImageListType } from 'react-images-uploading';
import { Grid } from '@material-ui/core';
import { JobModel } from '../NewsfeedModels';
import PendingAttachment from './PendingAttachment';
import JobCard from '../jobCard/JobCard';
import IProvider from 'models/Providers/IProvider';
import MiniInternalProviderCard from 'parent-portal/providers/cards/internal/MiniInternalProviderCard';
import { track } from 'shared';

interface IProps {
    images: ImageListType;
    setImages?: (imageList: never[]) => void;
    job?: JobModel;
    setJob?: (x: JobModel | undefined) => void;
    provider?: IProvider;
    setProvider?: (x: IProvider | undefined) => void;
}

export default function PendingAttachmentSection({ images, setImages, job, setJob, provider, setProvider }: IProps) {
    function onChange(imageList: ImageListType) {
        if (setImages) {
            setImages(imageList as never[]);
        }
    }

    const ImagePreview = () => {
        if (images.length > 0) {
            return (
                <ImageUploading multiple value={images} onChange={onChange} maxNumber={1}>
                    {({ imageList, onImageRemove }) => (
                        <Grid container spacing={3}>
                            {imageList.map((image, index) => (
                                <Grid item key={index}>
                                    <PendingAttachment onClose={() => onImageRemove(index)}>
                                        <Grid container>
                                            <img src={image.dataURL} alt="" width="100" />
                                        </Grid>
                                    </PendingAttachment>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </ImageUploading>
            );
        }

        return <></>;
    };

    const JobPreview = () => {
        if (job && setJob) {
            return (
                <PendingAttachment onClose={() => setJob(undefined)}>
                    <Grid container justify="flex-start">
                        <JobCard job={job} />
                    </Grid>
                </PendingAttachment>
            );
        }
        return <></>;
    };

    const ProviderPreview = () => {
        if (provider && setProvider) {
            return (
                <PendingAttachment onClose={() => setProvider(undefined)}>
                    <Grid container justify="flex-start">
                        <MiniInternalProviderCard
                            provider={provider}
                            onGoToProfile={() => {
                                track('Newsfeed: Pending Shared Provider go to Profile click');
                            }}
                        />
                    </Grid>
                </PendingAttachment>
            );
        }
        return <></>;
    };

    return images.length > 0 || job || provider ? (
        <Grid container style={{ paddingTop: 30 }}>
            <ImagePreview />
            <JobPreview />
            <ProviderPreview />
        </Grid>
    ) : (
        <></>
    );
}
